import { createRequestActions } from 'store/actionCreators'

// default page value in args needed for initial videos loading, when action will be called without params
export const fetchVideosByPage = createRequestActions('VIDEOS/FETCH_VIDEOS_BY_PAGE', (page = 1, perPage = 100) => ({
  request: {
    url: `/videos`,
    params: { page, perPage },
  },
}))
